module.exports = __webpack_public_path__ + "static/media/landing_page_subcontent_image.b1f2b409.svg";